/* BOKORA Suche: Tippfehler, Synonyme, Umlaute und Hersteller-Nummern.
   Schreibt die Suchanfrage um, bevor sie an die Shopify-Suche geht
   (Suchseite, Formular-Absenden und Schnellsuche im Kopf). */
(function () {
  'use strict';
  if (window.BK_SEARCH) return;
  /* Nummern, die die Shopify-Suche so nicht findet (Becker ohne Leerzeichen, Einzelnummern in SET-Artikeln) */
  var NR = {"49302000050":"SET-49302000050","49300406070":"SET-49300406070","49302000360":"SET-49302000360","49303000510":"SET-49303000510","49303000530":"SET-49303000530","49303000400":"SET-49303000400","49302000440":"SET-49302000440","49303003820":"SET-49303003820","49303001210":"SET-49303001210-49303001220","49303001220":"SET-49303001210-49303001220","49303004650":"SET-49303004650-49303004660","49303004660":"SET-49303004650-49303004660","49303000450":"SET-49303000450-49300006070","49300006070":"SET-49303000450-49300006070","4930300075":"SET-4930300075-49303000760","49303000760":"SET-4930300075-49303000760","49303000590":"SET-49303000590-49303006280","49303006280":"SET-49303000590-49303006280","49303000610":"SET-49303000610-49303000620","49303000620":"SET-49303000610-49303000620","4930300084":"SET-4930300084-49303004150","49303004150":"SET-4930300084-49303004150","49303002180":"SET-49303002180-49303002170","49303002170":"SET-49303002180-49303002170","49303000910":"SET-49303000910-49303000330","49303000330":"SET-49303000910-49303000330","20101100410":"2010 110 041 0","10101200030":"1010 120 003 0","10101200040":"1010 120 004 0","10201200020":"1020 120 002 0","10101200010":"1010 120 001 0","10101200020":"1010 120 002 0","10201200010":"1020 120 001 0","20101201390":"2010 120 139 0","20101201400":"2010 120 140 0","20201201190":"2020 120 119 0","20301201180":"2030 120 118 0","20401201150":"2040 120 115 0","20101201420":"2010 120 142 0","20101201430":"2010 120 143 0","20201201200":"2020 120 120 0","20301201200":"2030 120 120 0","20101205030":"2010 120 503 0","20101205040":"2010 120 504 0","20201205020":"2020 120 502 0","20301205020":"2030 120 502 0","20401205020":"2040 120 502 0","10101200070":"1010 120 007 0","10101200080":"1010 120 008 0","10201200060":"1020 120 006 0","20101201580":"2010 120 158 0","20101201590":"2010 120 159 0","20201201280":"2020 120 128 0","20301201280":"2030 120 128 0","20401201170":"2040 120 117 0","20101201630":"2010 120 163 0","20101201640":"2010 120 164 0","20201201320":"2020 120 132 0","20301201320":"2030 120 132 0","20401201190":"2040 120 119 0","20105200050":"2010 520 005 0","20105200060":"2010 520 006 0","20205200030":"2020 520 003 0","20305200030":"2030 520 003 0","20405200030":"2040 520 003 0","49010001550":"4901 000 155 0","49010002000":"4901 000 200 0","40020000010":"4002 000 001 0"};
  var BRANDS = /^(somfy|warema|becker|acomax|elero|caravita|geiger|dunker|eckermann)$/;
  var PH = [
    [/\bfern\s+bedienung/g, 'fernbedienung'], [/\bhand\s+sender/g, 'handsender'],
    [/\bwand\s+sender/g, 'wandsender'], [/\bzeit\s+schalt/g, 'zeitschalt'],
    [/\bfunk\s+empf/g, 'funkempf'], [/\brol+[aä]+den\s+(motor|antrieb)/g, 'rollladenmotor'],
    [/\bgurt\s+wi(c?k)ler/g, 'gurtwickler'], [/\bf(ue|ü|u)hrungs\s+schiene/g, 'führungsschiene']
  ];
  var TK = [
    [/^rol+[aä]+den/, 'rollladen'],
    [/^rollos?$/, 'rollladen'],
    [/^rollo(motor|antrieb)(e|en)?$/, 'rollladenmotor'],
    [/^rollladen(antrieb|antriebe|motoren)$/, 'rollladenmotor'],
    [/^ersatzmotor(en)?$/, 'rollladenmotor'],
    [/^(funk|hand)?fern(bedienung|bedinung|bedienng|bedienun|bediehnung|bedinnung|bediennung|steuerung)(en)?$/, 'handsender'],
    [/^(funk)?handsendern?$/, 'handsender'],
    [/^(au(ss|ß)en)?jal+o?u?s(ie|ien|ine|ienen)$/, 'raffstore'],
    [/^(au(ss|ß)en)?jal+o?u?s(ie|ien)?(motor|antrieb)(e|en)?$/, 'raffstoremotor'],
    [/^raf+stor(e|en)?$/, 'raffstore'],
    [/^raf+store?n?(motor|antrieb)(e|en)?$/, 'raffstoremotor'],
    [/^(funk)?empf(ae|ä|a|e)nger$/, 'funkempfänger'],
    [/^wind(waechter|wachter|wächter|messer|melder|sensor|wächtern)$/, 'windwächter'],
    [/^sonnen(waechter|wachter|wächter|messer|melder)$/, 'sonnenwächter'],
    [/^licht(sensor|wächter|waechter)$/, 'sonnensensor'],
    [/^(zeitschalter|zeitschaltung|zeitschaltuhren|zeitschaltur|zeitschlatuhr|schaltuhr|timer)$/, 'zeitschaltuhr'],
    [/^funk(wand)?(schalter|taster)$/, 'wandsender'],
    [/^(f(ue|ü|u)hrungsschiene|laufschiene)n?$/, 'führungsschiene'],
    [/^zubeh(oe|ö|o)r(teile)?$/, 'zubehör'],
    [/^(gurtband|gurtbänder|aufzugsgurt|rollladengurt)e?$/, 'rollladengurt'],
    [/^gurt(auf)?(roller|wickel|wikler|wickler|wicker)$/, 'gurtwickler'],
    [/^(hand)?kurbel(stange|n)?$/, 'kurbel'],
    [/^montagerahmen$/, 'rahmen'],
    [/^(einstell|programmier|montage)kabel$/, 'einstellkabel'],
    [/^markisen(antrieb|antriebe|motoren)$/, 'markisenmotor'],
    [/^rohrmotoren$/, 'rohrmotor'],
    [/^(akomax|acomacks|akkomax|accomax|acommax|acomac|akomaks|acomaks|acommaxx)$/, 'acomax'],
    [/^(beker|bekker|bäcker|baecker|becke)$/, 'becker'],
    [/^(warrema|varema|warena|werema|wareema|warama|wärema|warma|wahrema)$/, 'warema'],
    [/^(somfi|somphy|somfie|somfey|sonfy|somvy|somfiy|somfyy)$/, 'somfy'],
    [/^(carravita|caravitta|karavita)$/, 'caravita'],
    [/^(elerro|ellero|elereo)$/, 'elero']
  ];
  function acoType(t) {
    var m = t.match(/^(mx|zx|wx|fx|rx|ax|cx)-?([a-z]{1,3}\d?)(\d{3})?$/);
    if (!m) return t;
    var r = m[1].toUpperCase() + '-' + m[2].charAt(0).toUpperCase() + m[2].slice(1);
    return m[3] ? r + ' ' + m[3] : r;
  }
  function syn(t) {
    if (/\d{5,}/.test(t)) return t;
    for (var i = 0; i < TK.length; i++) { if (TK[i][0].test(t)) { t = t.replace(TK[i][0], TK[i][1]); } }
    return acoType(t);
  }
  function uml(t) {
    if (/uell|\d/.test(t)) return t;
    return t.replace(/(^|[^aeiouäöüq])(a|o|u)e/g, function (m, p, v) { return p + { a: 'ä', o: 'ö', u: 'ü' }[v]; })
            .replace(/^aussen/, 'außen');
  }
  function expand(q) {
    var o = (q || '').replace(/\s+/g, ' ').trim();
    if (!o || /\sOR\s|[:()"*]/.test(o)) return o;
    var s = o.toLowerCase();
    var numOnly = /^[#\d\s\-\/.+]+$/.test(s);
    var hit = null;
    s = s.replace(/#/g, ' ').replace(/\d[\d \-\/.]{3,}\d/g, function (seg) {
      var d = seg.replace(/\D/g, '');
      if (d.length < 5) return seg;
      if (NR[d]) { hit = NR[d]; return NR[d]; }
      return /[ \-\/.]/.test(seg) ? d : seg;
    }).replace(/\s+/g, ' ').trim();
    if (numOnly) return hit || s;
    PH.forEach(function (r) { s = s.replace(r[0], r[1]); });
    var t = s.split(' ').map(syn);
    // Marke nach vorne (bessere Treffer)
    t.sort(function (a, b) { return (BRANDS.test(b) ? 1 : 0) - (BRANDS.test(a) ? 1 : 0); });
    var v1 = t.join(' ');
    var v2 = t.map(uml).join(' ');
    if (v1 !== o.toLowerCase()) return v2 !== v1 ? v1 + ' OR ' + v2 : v1;
    if (v2 !== v1) return o + ' OR ' + v2;
    return o;
  }
  window.BK_SEARCH = { expand: expand };

  var isSearch = /^\/search\/?$/.test(location.pathname) || /^\/[a-z]{2}(-[a-z]{2})?\/search\/?$/.test(location.pathname);
  var params = new URLSearchParams(location.search);

  /* 1) Suchseite direkt aufgerufen (Link, Google, Schnellsuche): Anfrage verbessern */
  if (isSearch && params.get('q') && !params.get('bkq')) {
    var q0 = params.get('q'), ex0 = expand(q0);
    if (ex0 && ex0 !== q0) {
      params.set('q', ex0); params.set('bkq', q0);
      location.replace(location.pathname + '?' + params.toString());
      return;
    }
  }

  /* 2) Formular absenden: gleich die verbesserte Anfrage schicken */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || !/\/search\/?(\?|$)/.test(f.getAttribute('action') || f.action)) return;
    var inp = f.querySelector('input[name="q"]');
    if (!inp) return;
    var q = inp.value, ex = expand(q);
    if (!ex || ex === q.trim()) return;
    e.preventDefault();
    var fd = new FormData(f), p = new URLSearchParams();
    fd.forEach(function (v, k) { if (k !== 'q' && typeof v === 'string') p.append(k, v); });
    p.set('q', ex); p.set('bkq', q);
    location.href = (f.getAttribute('action') || '/search') + '?' + p.toString();
  }, true);

  /* 3) Schnellsuche im Kopf: Anfrage vor dem Abruf verbessern */
  var of = window.fetch;
  if (of) {
    window.fetch = function (u, opt) {
      try {
        var us = typeof u === 'string' ? u : (u && u.url);
        if (us && us.indexOf('/search/suggest') > -1) {
          var U = new URL(us, location.origin), q = U.searchParams.get('q') || '';
          if (q.indexOf('product_type:') < 0) {
            var ex = expand(q);
            if (ex && ex !== q) { U.searchParams.set('q', ex); return of.call(this, U.toString(), opt); }
          }
        }
      } catch (err) {}
      return of.apply(this, arguments);
    };
  }

  /* 4) Suchseite: Hinweis "Sie suchten ..." und Originalbegriff im Suchfeld */
  if (isSearch && params.get('bkq')) {
    document.addEventListener('DOMContentLoaded', function () {
      var orig = params.get('bkq'), used = params.get('q') || '';
      var shown = used.split(' OR ')[0];
      document.querySelectorAll('input[name="q"]').forEach(function (i) { i.value = orig; });
      try { document.title = document.title.split(used).join(shown); } catch (e) {}
      if (shown.toLowerCase() !== orig.trim().toLowerCase()) {
        var hd = document.querySelector('.template-search__header');
        if (hd && !document.querySelector('.bks-note')) {
          var n = document.createElement('p');
          n.className = 'bks-note';
          n.appendChild(document.createTextNode('Ergebnisse für „' + shown + '“ – Sie suchten „' + orig + '“. '));
          var a = document.createElement('a');
          a.href = location.pathname + '?q=' + encodeURIComponent(orig) + '&bkq=' + encodeURIComponent(orig) + '&type=product';
          a.textContent = 'Nur nach „' + orig + '“ suchen';
          n.appendChild(a);
          hd.appendChild(n);
        }
      }
    });
  }
})();
